import { ModalProps } from 'antd';
import { ComponentType, Suspense, useEffect, useState } from 'react';
import useModalState from '../hooks/use-modal-state';

export type LazyModalComponentProps = {
  isOpen: boolean;
  afterClose: ModalProps['afterClose'];
};

interface Props {
  modalId: string;
  Component: ComponentType<LazyModalComponentProps>;
}

const LazyModal = ({ modalId, Component }: Props) => {
  const [modalState, modalProps] = useModalState(modalId);
  const [isContentVisible, setIsContentVisible] = useState(false);

  const handleAfterClose = () => {
    setIsContentVisible(false);
  };

  useEffect(() => {
    if (modalState) {
      setIsContentVisible(true);
    }
  }, [modalState]);

  return (
    <Suspense>
      {isContentVisible && <Component isOpen={modalState} afterClose={handleAfterClose} {...modalProps} />}
    </Suspense>
  );
};

export default LazyModal;
